<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <div class="header-image-gradient" style="background-image: url(static/images/img1.jpg); background-position: top;">
                        <div class="layer-gradient" style="padding-top: 20px;">
                        </div>
                    </div>     

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <!-- <div class="col-xl-12" v-show="data.itens.length == 0 && data.loaded">
                            <div class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>                            
                        </div>   -->           
                        <div class="col-lg-12">
                          
                            <p class="page-text margin-bottom-10">
                                <b>Escolha o profissional</b> desejado para ver os <b>horários disponíveis</b> e realizar o <b>agendamento</b>.
                            </p>
                        </div>                                     
                        <div class="col-xl-12">
                            <div class="dashboard-box margin-top-0 cards">
                                <div class="content">
                                    <h5 class="block-title hidden-lg hidden-md hidden-xl hidden-sm">
                                        <i class="las la-stethoscope"></i>
                                        Profissionais disponíveis
                                    </h5>
                                    
                                    <h5 v-if="data.itens.length == 0 && data.loaded" class="empty">
                                        <i class="las la-times"></i>                                           
                                        Nenhum resultado encontrado.
                                    </h5>   
                                    <div class="dashboard-box-list margin-top-0 row">
                                        <div class="col-xl-4 col-xs-6" v-for="(item, index) in data.itens">
                                            <router-link :to="{'name': 'Agenda', 'query': {'c': item.cod}}" class="job-listing card">
                                                <div class="header-image" :style="{'background-image': 'url(' + item.imagem + ')'}">
                                                    <span class="dashboard-status-button">
                                                        {{item.categorias}}
                                                    </span>                                                    
                                                </div>
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description center">
                                                        <h3 class="job-listing-title margin-bottom-5 center padding-right-0">{{item.nome}}</h3>
                                                        <p class="margin-top-0 margin-bottom-5 center">
                                                            {{item.descricao}}
                                                        </p>                                                    
                                                        <router-link :to="{'name': 'Agenda', 'query': {'c': item.cod}}" class="button small block-mobile">
                                                            <i class="las la-calendar-check"></i>
                                                            Ver Agenda
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </router-link>              
                                        </div>                                                                           
                                    </div>
                                </div>
             
                    
                            </div>                            
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Profissionais',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "data":                 {
                "itens":            []
            },     
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "profissional"
            },
        }
    },
    watch: {
                  
    },
    methods: {                   
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {

                if (self.$root.tmp.profissionais.itens.length > 0) {
                    self.data  = JSON.parse(JSON.stringify(self.$root.tmp.profissionais));
                    loading.hide();
                    resolve(true);
                }


                axios.get("api/usuarios.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = response.data.result;
                    self.$root.tmp.profissionais = JSON.parse(JSON.stringify(response.data.result));
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }
    },
    created: function() {
        var self = this;

        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {
        
            self.$forceUpdate();
            loading.hide();
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {

    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*.job-listing {
        display: inline-block;
        width: 45%;
    }*/
    .header-image {
        height: 20vh;
        margin-top: -1px !important;
        margin-left: -1px !important;
        margin-right: -1px !important;
        position: relative;
    }


    .dashboard-box .job-listing-details {
        padding: 10px;
        height: 128px;
        align-items: center;
        padding-bottom: 40px !important;            
    }

    .dashboard-box .job-listing-details .button {
        padding: 5px;
        font-size: 14px;
        font-weight: 300;
        /*letter-spacing: 1px;*/
        /*margin-top: 15px;*/
        position: absolute;
        bottom: -1px;
        top: auto;
        left: -1px;
        right: -1px;
        display: block;
        width: auto;
        color: #fff;
        /*margin-left: -11px;*/
        /*margin-right: -11px;*/
        /*margin-bottom: -11px;*/
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }

    .job-listing {
        padding-left: 0px;
        padding-right: 0px;
    }
    .job-listing h3.job-listing-title {
        font-size: 15px;
        color: #333;
        line-height: 18px;
        font-weight: 500;
    }
    .job-listing .dashboard-status-button {
        font-size: 11px;
        background: #ddd;
        color: #fff !important;
        letter-spacing: 0.5px;
        /*font-weight: 500;*/
        padding: 0px 5px;
        color: #000 !important;
        position: absolute;
        /*bottom: 5px;*/
        left: 5px;
        bottom: 5px;
        line-height: 16px;
        font-weight: 400;
        top: auto;
        margin-right: 5px;
        text-align: center;
        /*top: 12.3em;*/
    }

    .job-listing p {
        font-size: 12px;
        line-height: 120%;
    }
   
</style>



// WEBPACK FOOTER //
// src/components/Profissionais.vue